<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Dd2ATp/tc-custom/9781638292425.jpg?1705541208811" alt="This image is the cover for the book Poems from the Third Rail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Poems from the Third Rail
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'><span style="color:#252525;">This all-too-real collection of poems is one man</span><span style="color:#252525;">’</span><span style="color:#252525;">s shocking account of a lifelong struggle with mental illness, substance abuse, and poverty. On each page, you will feel his sorrow and pain. In every poem, you will see his soul and witness the darkness and flickering glow of early recovery.<br/><br/>You will see the world through his eyes and his recordings of modern times. This diverse collection touches on faith, addiction, religion, mindfulness, philosophy, life, and his innermost thoughts on everything. He leaves nothing unrevealed.</span></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'><span style="color:#252525;">This book is for anyone who suffers from the human condition, is sick and suffering, or is struggling to regain control of an aspect of their life that they want back.</span></p><p style='margin-right: 0cm; margin-left: 0cm; font-size: 16px; font-family: "Times New Roman", serif; text-align: justify;'><span style="color:#252525;"><br/>And for all the people who just like watching trains crash</span></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'><span style="color:#252525;">Over and over</span></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'><span style="color:#252525;">Again</span></p><p style="margin: 0cm 0cm 8pt; font-size: 15px; font-family: Calibri, sans-serif;"><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        C.J. Caj
      </h2>
      
      <p class="authorDescription body article"><p class="BodyA" style='margin: 0cm 0cm 0.0001pt; font-size: 16px; font-family: "Times New Roman", serif; color: black; text-align: justify;'><span style="font-size:15px;">C.J. Caj was born in Winthrop, Massachusetts. He grew up with his five older sisters and a single working mother, a nurse, living in poverty. He was trained and worked as a chef in both Boston and Munich, Germany. Caj is recovering from both alcohol and drug addiction. This is the world through his eyes.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?433b8f1e